/**
 * Development environment detection.
 * Bundlers replace this at build time.
 */
export function isNodeDevEnvironment(): boolean {
  return process.env.NODE_ENV === 'development';
}
